import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const reversalApis = createApi({
  reducerPath: "reversalApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["companyService", "generalServices"],
  endpoints: (build) => ({
    initReversal: build.mutation<
      void,
      { companyId: number; serviceId: number; data: ReversalData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/transaction-reversals/init-reversal`,
        method: "POST",
        body: data,
      }),
    }),
    authReversal: build.mutation<
      void,
      { companyId: number; serviceId: number; data: ReversalData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/transaction-reversals/authorize-reversal`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});
